module.exports = __webpack_public_path__ + "static/media/icon_eye-closed.18979b60.svg";